'use strict';

export async function LoadDiagramBackground(svgRoot) {
  return new Promise((resolve, reject) => {
    d3.xml("images/findings-bg-old.svg", "image/svg+xml", function (xml) {
      let importedNode = document.importNode(xml.documentElement, true).firstElementChild;
      svgRoot.node().appendChild(importedNode);
      resolve(importedNode);
    });
  });
}



// WEBPACK FOOTER //
// ./src/scripts/services/findingsBg.js